import React, { createContext, useState } from "react";
export const ForgotPasswordContext = createContext({});
import validateEmail from "../../utils/service";
import { useNavigate } from "react-router-dom";
import RouteConstants from "../../constants/routesContent.json";
import { forgotPasswordApi } from "../../api/Api";
export const ForgotPasswordContextProvider = ({ children }) => {
  const navigate = useNavigate();
  const [forgotEmailId, setForgotEmailId] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [invalidEmail, setInvalidEmail] = useState(false);
  const submitForgotPassword = async () => {
    const userData = {
      email: forgotEmailId,
    };
    if (!validateEmail(forgotEmailId)) {
      setInvalidEmail(true);
    } else {
      setInvalidEmail(false);
    }
    if (validateEmail(forgotEmailId)) {
      try {
        setSpinnerStatus(true);
        const submitEmail = await forgotPasswordApi(userData);

        if (submitEmail.data.status === 200) {
          navigate(RouteConstants.EMAIL_VERIFICATION);
          setSpinnerStatus(false);
          setAlertMessage(submitEmail.data.message);
        }
      } catch (error) {
        if (
          error.response.data.status === 401 ||
          error.response.data.status === 400
        ) {
          const errorMessage = error.response.data.message;
          setShowAlert(true);
          setSpinnerStatus(false);
          setAlertMessage(errorMessage);
        } else {
          setShowAlert(true);
          setAlertMessage("Somethingwent wrong");
        }
      }
    }
  };
  const providerValue = {
    submitForgotPassword,
    alertMessage,
    forgotEmailId,
    setForgotEmailId,
    invalidEmail,
    setInvalidEmail,
    spinnerStatus,
    showAlert,
    setShowAlert,
  };

  return (
    <ForgotPasswordContext.Provider value={providerValue}>
      {children}
    </ForgotPasswordContext.Provider>
  );
};
